var slider = {exports: {}};

export { slider as __module };
